import { createConcurrentCustomMetric } from '../../metricConfigs.ts';
import { TIME_TO_APP_IDLE_KEY } from '../../metric-keys/index.ts';

export const TIME_TO_APP_IDLE_METRIC = createConcurrentCustomMetric({
	key: TIME_TO_APP_IDLE_KEY,
});
